import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.1 1.231a.999.999 0 0 1 1.8 0l1.507 3.14c.048.1.144.169.255.183l3.47.455c.83.109 1.167 1.13.556 1.707L12.15 9.109a.33.33 0 0 0-.097.296l.637 3.418c.154.826-.721 1.451-1.455 1.056l-3.077-1.66a.33.33 0 0 0-.316 0l-3.077 1.66c-.734.395-1.61-.23-1.456-1.056l.638-3.418a.33.33 0 0 0-.097-.296L1.313 6.716c-.612-.577-.275-1.598.555-1.707l3.47-.455a.33.33 0 0 0 .255-.183z"
	})
});
export default SvgStarFilled;
